import { useContext } from 'react';

import { CommentActionsContext, CommentStateContext } from '../context/CommentContext';

export const useCommentStateContext = () => {
  const context = useContext(CommentStateContext);

  if (context === undefined) {
    throw new Error('useCommentStateContext must be used within a CommentProvider');
  }

  return context;
};

export const useCommentActionsContext = () => {
  const context = useContext(CommentActionsContext);

  if (context === undefined) {
    throw new Error('useCommentActionsContext must be used within a CommentProvider');
  }

  return context;
};
